import { h, Fragment } from 'preact';
import { useStore } from 'src/hooks';
import UserType from 'src/common/usertype';
import SidebarScreenname from './screenname';
import SidebarNavigationChathost from './navigation/chathost';
import SidebarNavigationStudio from './navigation/studio';
import SocialLinks from './social-links';
import PromoCountdown from './promo/countdown';
import PromoLogo from './promo/logo';
import * as styles from './styles.less';

interface SidebarProps {
    isFrame?: boolean;
    sidebarType: UserType;
}

const Sidebar = ({ isFrame, sidebarType }: SidebarProps) => {
    const ctx = useStore();
    const displayScreenName = ctx.user.isLoggedIn.value && sidebarType === ctx.user.userTypeID.value;

    return (
        <div class={styles.sidebar}>
            {ctx.promo.phaseCounter.value ? <PromoCountdown isFrame={isFrame} /> : ctx.promo.phaseEvent.value ? <PromoLogo isFrame={isFrame} /> : null}

            {displayScreenName && <SidebarScreenname />}
            {sidebarType === UserType.CHATHOST && (
                <>
                    <SidebarNavigationChathost isFrame={isFrame} />
                </>
            )}
            {sidebarType === UserType.STUDIO && (
                <>
                    <SidebarNavigationStudio isFrame={isFrame} />
                </>
            )}
            <SocialLinks />
        </div>
    );
};

export default Sidebar;
